import { GoogleAuthProvider, signInWithPopup } from "firebase/auth"

import { AlertModal } from "../../../components"
import { auth } from "../../../configs/firebase"
import { useNavigate } from "react-router-dom"
import { useState } from "react"
import { useTranslation } from "react-i18next"

const SignIn = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [alertOpen, setAlertOpen] = useState(false)
  const [alertMsg, setAlertMsg] = useState("")

  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider()
    try {
      await signInWithPopup(auth, provider)
      navigate("/dashboard")
    } catch (err) {
      console.error("Google sign-in error:", err)
      setAlertMsg(
        t("auth.failedToSignInWithGoogle", {
          defaultValue: "Failed to sign in with Google",
        })
      )
      setAlertOpen(true)
    }
  }

  return (
    <div className="min-h-screen bg-dark-default flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-xl">
        <h1 className="text-3xl md:text-4xl font-bold text-light-default text-center mb-2">
          {t("auth.welcomeTitle", { defaultValue: "Welcome" })}
        </h1>
        <p className="text-base md:text-lg text-light-default text-center mb-8">
          {t("auth.signInToContinue", { defaultValue: "Sign in to continue" })}
        </p>

        <div className="flex flex-col gap-4">
          <button
            onClick={handleGoogleSignIn}
            className="flex items-center justify-center gap-3 px-6 py-4 rounded-xl min-h-[56px] bg-light-default border border-light-default text-dark-default font-semibold hover:bg-light-t-lighten-1 transition"
          >
            <img
              src="https://www.svgrepo.com/show/475656/google-color.svg"
              alt="Google logo"
              className="w-6 h-6"
            />
            <span className="text-base md:text-lg">
              {t("auth.signInWithGoogle")}
            </span>
          </button>
        </div>
      </div>

      <AlertModal
        open={alertOpen}
        title={t("common.error", { defaultValue: "Error" })}
        message={alertMsg}
        onClose={() => setAlertOpen(false)}
      />
    </div>
  )
}

export default SignIn
